<template>
  <div class="right">
    <div class="right_title">
      <div class="right_title_ch">今日进出信息</div>
      <div class="right_title_en">Temperature index of the park</div>
    </div>
    <div class="right_ftoday">
      <div class="right_ftoday_side">
        <dv-digital-flop :config="monitorEnter" style="width:118px;height:30px;" />
        <p>进园</p>
      </div>
      <div class="right_ftoday_mid">
        <!-- <div>132</div> -->
        <dv-digital-flop :config="monitorAll" style="width:103px;height:30px;" />
        <p>总人流量</p>
      </div>
      <div class="right_ftoday_side">
        <dv-digital-flop :config="monitorOut" style="width:118px;height:30px;" />
        <p>出园</p>
      </div>
    </div>
    <div class="right_title">
      <div class="right_title_ch">重点区域监控</div>
      <div class="right_title_en">Monitoring of key areas</div>
    </div>
    <div class="right_fmonitor">
      <div class="right_fmonitor_left">
        <dv-digital-flop :config="monitorRealTime" style="width:118px;height:30px;" />
        <p>数量监控</p>
      </div>
      <div class="right_fmonitor_right">
        <img src="../img/img.jpg" style="width: 270px; height: 155px" />
      </div>
    </div>
    <div class="right_title">
      <div class="right_title_ch">用电量TOP10</div>
      <div class="right_title_en">Electricity consumption</div>
    </div>
    <div class="rihgt_ftop">
      <dv-scroll-board :config="config" style="width:374px; float: right;" />
    </div>
  </div>
</template>

<script>
  // right - 安防管理

  export default {
    name: "BottomTab",
    components: {},
    data() {
      return {
        // 总人流量
        monitorAll: {
          number: [13],
          content: "{nt}",
          style: {
            fontSize: 22,
            fill: '#c97c0e',
            fontWeight: 'bold'
          }
        },
        // 进园
        monitorEnter: {
          number: [23],
          content: "{nt}",
          style: {
            fontSize: 22,
            fill: '#c97c0e',
            fontWeight: 'bold'
          }
        },
        // 出园
        monitorOut: {
          number: [23],
          content: "{nt}",
          style: {
            fontSize: 22,
            fill: '#c97c0e',
            fontWeight: 'bold'
          }
        },
        // 数量监控
        monitorRealTime: {
          number: [23],
          content: "{nt}",
          style: {
            fontSize: 22,
            fill: '#c97c0e',
            fontWeight: 'bold'
          }
        },
        config: {
          header: ["时间", "位置", "状态"],
          data: [
            ["2/14/21", "F区2楼1003室烟雾报警", "中危"],
            ["2/15/21", "F区2楼1004室烟雾报警", "高危"],
            ["2/16/21", "F区2楼1005室烟雾报警", "中危"],
            ["2/17/21", "F区2楼1006室烟雾报警", "高危"],
            ["2/18/21", "F区2楼1007室烟雾报警", "中危"],
            ["2/19/21", "F区2楼1008室烟雾报警", "高危"],
            ["2/20/21", "F区2楼1007室烟雾报警", "中危"],
            ["2/21/21", "F区2楼1008室烟雾报警", "高危"],
          ],
          headerBGC: 'transparent', // 表头背景色
          oddRowBGC: 'transparent', // 奇数行背景色
          evenRowBGC: '#293135', // 偶数行背景色
          columnWidth: [100, 200, 80], // 列宽
          rowNum: 7,
          headerHeight: 35, // 行高
        },
      };
    },
    mounted(){
      this.updateHandler();
    },
    methods: {
      updateHandler() {
        /**
         * 只是这样做是无效
         * config指向的内存地址没有发生变化
         * 组件无法侦知数据变化
         */
        this.monitorEnter.number[0] = 184;
        this.monitorAll.number[0] = 132;
        this.monitorOut.number[0] = 124
        this.monitorRealTime.number[0] = 56

        /**
         * 使用ES6拓展运算符生成新的props对象
         * 组件侦知数据变化 自动刷新状态
         */
        this.monitorEnter = { ...this.monitorEnter };
        this.monitorAll = { ...this.monitorAll };
        this.monitorOut = { ...this.monitorOut };
        this.monitorRealTime = { ...this.monitorRealTime };
      },
    }
  };
</script>

<style lang="less">
  .right_title {
    height: 35px;
    line-height: 35px;
    overflow: hidden;
    width: 400px;
    font-family: sans-serif;
    display: flex;
    margin: 12px auto 0;
    background: url(../img/bg_rightline.png) center bottom no-repeat;
    .right_title_ch {
      position: relative;
      font-size: 18px;
      letter-spacing: 2px;
      color: #fff;
      font-weight: bold;
      width: 160px;
      flex-shrink: 0;
    }
    .right_title_ch::before {
      position: absolute;
      content: "";
      right: 0;
      top: 10px;
      width: 2px;
      height: 13px;
      background: #b3c4c9;
    }
    .right_title_en {
      font-size: 11px;
      letter-spacing: 1px;
      color: #b3c4c9;
      padding-left: 10px;
    }
  }
  .right_ftoday {
    width: 346px;
    height: 92px;
    margin: 20px auto 0;
    border: 1px solid #c97c0e;
    border-radius: 10px;
    display: flex;
    p {
      margin: 0;
      padding: 0;
    }
    .right_ftoday_side {
      width: 118px;
      text-align: center;
      div {
        font-size: 22px;
        height: 33px;
        line-height: 33px;
        color: #c97c0e;
        font-weight: bold;
        margin-top: 22px;
      }
      p {
        font-size: 17px;
        height: 32px;
        line-height: 32px;
        color: #b3c4c9;
        letter-spacing: 2px;
      }
    }
    .right_ftoday_mid {
      background: url(../img/bg_ftoday.png) no-repeat;
      width: 103px;
      height: 92px;
      text-align: center;
      div {
        font-size: 22px;
        height: 33px;
        line-height: 33px;
        color: #c97c0e;
        font-weight: bold;
        margin-top: 22px;
      }
      p {
        font-size: 12px;
        height: 20px;
        line-height: 20px;
        color: #b3c4c9;
        letter-spacing: 2px;
      }
    }
  }
  .right_fmonitor {
    overflow: hidden;
    width: 400px;
    height: auto;
    overflow: hidden;
    margin: 10px auto 0;
    display: flex;
    font-family: sans-serif;
    .right_fmonitor_left {
      width: 130px;
      text-align: center;
      background: url(../img/bg_monitor.png) center 18px no-repeat;
      p {
        margin: 0;
        padding: 0;
      }
      div {
        font-size: 22px;
        height: 33px;
        line-height: 33px;
        color: #c97c0e;
        font-weight: bold;
        margin-top: 98px;
      }
      p {
        font-size: 17px;
        height: 20px;
        line-height: 20px;
        color: #b3c4c9;
        letter-spacing: 2px;
      }
    }
    .right_fmonitor_right {
      width: 270px;
      height: 155px;
    }
  }
  .rihgt_ftop {
    overflow: hidden;
    width: 400px;
    height: 155px;
    overflow: hidden;
    margin: 10px auto 0;
    font-family: sans-serif;
    background: url(../img/bg_ftop.png) center left no-repeat;
  }
  .dv-scroll-board .header{
    background: transparent !important;
    font-weight: bold;
  }
</style>
